import { render, staticRenderFns } from "./InformedConsent.vue?vue&type=template&id=61bcfe2e"
import script from "./InformedConsent.vue?vue&type=script&lang=js"
export * from "./InformedConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports